(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("beaver", [], factory);
	else if(typeof exports === 'object')
		exports["beaver"] = factory();
	else
		root["beaver"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 